import React from 'react';
import styled from 'styled-components';

import { style, userActions, useCurrentUser, useDispatch } from '../../api';
import Uploadable from './Uploadable';

const UserImageWrapper = ({
  src,
  isOnline,
  className,
  size,
  displayStatus,
  editable = false,
}: {
  src: string;
  isOnline?: boolean;
  className?: string;
  size?: number;
  displayStatus: boolean;
  editable?: boolean;
}) => {
  const user = useCurrentUser();
  const dispatch = useDispatch();
  const currentUserId = user?.id;

  return (
    <div className={className}>
      {currentUserId && editable ? (
        <>
          <Uploadable
            onUpload={async (file) => {
              if (file) {
                const data = new FormData();
                data.append('profile', file);
                await dispatch(userActions.updatePhoto(data));
              }
            }}
          >
            <UserImage src={src} size={size} />
            {displayStatus && <UserImageOnlineIndicator isOnline={isOnline} />}
          </Uploadable>
        </>
      ) : (
        <>
          <UserImage src={src} size={size} />
          {displayStatus && <UserImageOnlineIndicator isOnline={isOnline} />}
        </>
      )}
    </div>
  );
};

const UserImageOnlineIndicator = styled.div<{ isOnline?: boolean }>`
  position: absolute;
  top: 8%;
  right: 12%;
  height: 12px;
  width: 12px;
  z-index: 10;
  border-radius: 6px;
  border: 2px solid white;
  background-color: ${(p) => (p.isOnline ? style.green : style.grey2)};
`;

const UserImage = styled.img<{ size?: number }>`
  object-fit: cover;

  border-radius: 50%;
  background-color: white;
  width: ${(p) => (p.size ? `${p.size}px` : '100%')};
  height: ${(p) => (p.size ? `${p.size}px` : '100%')};
  border: 3px solid white;
`;

export default styled(UserImageWrapper)<{ size?: number }>`
  width: ${(p) => (p.size ? `${p.size}px` : '100%')};
  height: ${(p) => (p.size ? `${p.size}px` : '100%')};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  ${Uploadable} {
    border-radius: 50%;
    width: ${(p) => (p.size ? `${p.size}px` : '100%')};
    height: ${(p) => (p.size ? `${p.size}px` : '100%')};
  }
`;
